<template>
    <div class="registry-message">
        <div class="btn_content">
            <span v-has="buttonAuth[0]" @click="handleSave" class="btn"><i class="el-icon-check" style="margin-right: 5px;"></i>保存</span>
            <span v-has="buttonAuth[1]" v-if="changeVisible" @click="openChangeInformation" class="btn"><i class="el-icon-document" style="margin-right: 5px;"></i>变更申请</span>
            <span v-has="buttonAuth[2]" @click="handleSubmit" class="btn"><i class="el-icon-folder-checked" style="margin-right: 5px;"></i>提交</span>
        </div>
        <field-input-list
            ref="fieldInputs"
            class="reg_list"
            :fields="fields"
            :overseaSwitch="supplierTab.overseaSwitch"
        ></field-input-list>
        <changeInformationDialog
            @closeDialog="closeDialog"
            :openChangeDialog="openChangeDialog"
            :showFinanceForm="showFinanceForm"
            :title="'变更申请'"
            :basicForm="basicForm"
            :financeForm="financeForm"
            :tableData="tableData"
            :changeType="'0'"
            :supplierTab="supplierTab"
            @submitCallback="submitCallback">
        </changeInformationDialog>
    </div>
</template>

<script>
import changeInformationDialog from '../../../../components/changeInformationDialog';
import FieldInputList from '../../../../components/FieldInputList/Index.vue';
import { getSupplierDetail, saveSupplierDetail, commitSupplierDetail } from '../../../../api/registryMessageApi';
import { supplierBasicSubmit, supplierFinanceSubmit, changeApplyBtn } from '../../../../api/changeDetails.js';
import { REGISTRY_MESSAGE_FIELDS, SUPPLIER_STATUS } from '../../../../constant/constant';

const BUTTON_AUTH = ['08000101', '08000102', '08000103'];
export default {
    name: 'TabRegistryMessage',
    components: { changeInformationDialog, FieldInputList },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierCode: '',
                    propertyNature: ''
                };
            }
        }
    },
    data() {
        return {
            openChangeDialog: false,
            supplierCode: null,
            propertyNature: null,
            fields: {},
            basicForm: {},
            financeForm: {},
            tableData: [],
            showFinanceForm: false,
            supplierStatus: null,
            multipleFields: [],
            buttonAuth: BUTTON_AUTH
        };
    },
    computed: {
        userCode() {
            return this.$store.state.user.userCode;
            // return '11_0005'; // 测试userCode
        },
        changeVisible() {
            return this.supplierStatus === SUPPLIER_STATUS.QUALIFIED;
        },
        statusEffect() {
            let affect = false;
            if (this.supplierStatus === SUPPLIER_STATUS.APPEND || this.supplierStatus === SUPPLIER_STATUS.POTENTIAL || this.supplierStatus === SUPPLIER_STATUS.REJECT) {
                affect = false;
            } else if (this.supplierStatus === SUPPLIER_STATUS.QUALIFIED || this.supplierStatus === SUPPLIER_STATUS.CLEAR || this.supplierStatus === SUPPLIER_STATUS.QUIT) {
                affect = true;
            }
            return affect;
        }
    },
    methods: {
        handleSave(callback) {
            const fields = this.$refs.fieldInputs.getAllInputs();
            if (fields) {
                this.multipleFields.forEach(item => {
                    fields[item] = fields[item] && fields[item].length > 0 ? fields[item].join(',') : '';
                });
                saveSupplierDetail(fields).then(res => {
                    if (res && +res.code === 0) {
                        this.getDetail({
                            supplierCode: this.supplierCode,
                            propertyNature: this.propertyNature
                        });
                        if (callback instanceof Function) {
                            callback();
                            return false;
                        }
                        this.$message({
                            type: 'success',
                            message: `保存成功!`
                        });
                    }
                });
            }
        },
        handleSubmit() {
            this.handleSave(() => {
                const fields = this.$refs.fieldInputs.getAllInputs();
                if (fields) {
                    commitSupplierDetail({ supplierCode: this.supplierCode }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message({
                                type: 'success',
                                message: `提交成功!`
                            });
                        }
                    });
                }
            });
        },
        openChangeInformation(data) {
            if (this.supplierTab.propertyNature + '' === '2') {
                this.showFinanceForm = false;
                this.tableData = [{
                    qualificationName: '身份证人像面'
                }, {
                    qualificationName: '身份证国徽面'
                }];
            } else {
                this.showFinanceForm = true;
                this.tableData = [{
                    qualificationName: '身份证人像面'
                }, {
                    qualificationName: '身份证国徽面'
                }, {
                    qualificationName: '营业执照'
                }];
            }
            const params = {
                supplierCode: this.supplierTab.supplierCode,
                isShowRejectButton: '1'
            };
            changeApplyBtn(params).then(res => {
                if (res && res.code === '0') {
                    const code = { supplierCode: this.supplierTab.supplierCode, isShowRejectButton: '1' };
                    this.basicForm = Object.assign(res.data.basicAfter, code);
                    this.financeForm = Object.assign(res.data.financeAfter, code);
                    const tmp = res.data.basicAfter;
                    if (tmp.list) {
                        this.tableData = tmp.list;
                    }
                    this.openChangeDialog = true;
                }
            });
        },
        closeDialog(data) {
            this.openChangeDialog = data;
        },
        confirmDialog(data) {
            this.openChangeDialog = data;
        },
        setFields(data) {
            const fields = {};
            const disabledOfFields = {};
            const requiredOfFields = {};
            const multipleFields = [];
            const filtedFields = REGISTRY_MESSAGE_FIELDS.filter(field => {
                let hasField = false;
                const authList = field.auth.filter(iAuth => {
                    return iAuth.propertyNature + '' === this.propertyNature + '';
                });
                if (authList.length > 0) {
                    hasField = true;
                    disabledOfFields[field.code] = !!authList[0].disabled;
                    requiredOfFields[field.code] = !!authList[0].required;
                }
                return hasField;
            });
            filtedFields.forEach(item => {
                let value = data[item.code];
                if (item.type === 'multiple') {
                    multipleFields.push(item.code);
                    value = value ? value.split(',') : value;
                }
                fields[item.code] = {
                    name: item.name,
                    type: item.type,
                    required: requiredOfFields[item.code],
                    disabled: disabledOfFields[item.code],
                    value
                };
                // 根据供应商状态使字段置灰
                if ((this.statusEffect && item.code === 'paymentTerms') || (this.statusEffect && item.code === 'paymentType')) {
                    fields[item.code].disabled = true;
                }
            });
            this.multipleFields = multipleFields;
            this.fields = fields;
        },
        // getInFo() {
        //     getSupplierInfo(this.userCode).then(res => {
        //         if (res && res.data) {
        //             window.console.log('getSupplierInfo', res);
        //             this.supplierCode = res.data.supplierCode;
        //             this.propertyNature = res.data.propertyNature;
        //             this.getDetail({
        //                 supplierCode: this.supplierCode,
        //                 propertyNature: this.propertyNature
        //             });
        //         }
        //     });
        // },
        getDetail(params) {
            getSupplierDetail(params).then(res => {
                if (res && res.data) {
                    this.supplierStatus = res.data.supplierStatus;
                    this.setFields(res.data);
                }
            });
        },
        submitCallback(data) {
            if (data.changeType === 'basicForm') {
                supplierBasicSubmit(data.data).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('提交成功');
                        this.closeDialog();
                    }
                });
            } else if (data.changeType === 'financeForm') {
                supplierFinanceSubmit(data.data).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('提交成功');
                        this.closeDialog();
                    }
                });
            }
        }
    },
    mounted() {
        // this.getInFo();
    },
    watch: {
        supplierTab(val) {
            if (val) {
                this.supplierCode = val.supplierCode;
                this.propertyNature = val.propertyNature;
                this.getDetail({
                    supplierCode: this.supplierCode,
                    propertyNature: this.propertyNature
                });
            }
        }
    }
};
</script>

<style lang="less">
    .registry-message {
        width: 100%;
        .el-select {
            width: 100%;
            min-width: 120px;
        }
        .el-input {
            width: 100%;
            min-width: 120px;
        }
        .el-date-editor.el-input {
            width: 100%;
            min-width: 120px;
        }
        .btn_content {
            height: 28px;
            width: 100%;
            box-sizing: border-box;
            line-height: 28px;
            margin-bottom: 10px; ;
            background-color: #fffbf2 ;
            border: 1px solid #ffece3;
            font-size: 12px;
            color: #666;
            .btn {
                cursor: pointer;
                margin-left: 20px;
            }
        }
    }
</style>